import {transmitFreeviewEmail} from "./Brevo";

/** Signup email capture is best effort and must never block registration or payment. */
export default async function EmailFreeViewAPI(
    abortController: AbortController,
    email: string,
): Promise<boolean | undefined> {
    try {
        await transmitFreeviewEmail(abortController, email);
        return true;
    } catch {
        return undefined;
    }
}
